import React from "react";
import MultiSelectTags from "../../../actualite/tags/MultiSelectTags.js";

const SelectTags = ({ event, directEvent,  onChange }) => {

    const handleTagChange = (event) => {
        onChange('tags', event.target.value)
    };

    return (
    <div className="select-team">
        <MultiSelectTags match={directEvent} tags={event.tags} handleTagChange={handleTagChange} />
    </div>
    );
};

export default SelectTags;
